// Plan routines
import $ from 'jquery';
import * as Site from "../js/site";
import * as Constants from "./constants";
import { is } from 'core-js/core/object';

let EsriModules;
let highlightGraphicsLayer;

let plansDetailTable = [];
let plansMasterTable = [];

let showTableClass = "fas fa-angle-double-right";
let hideTableClass = "fas fa-angle-double-down";

let hoverGraphic;
let masterHighlightSymbol;
let planBoundarySymbol, planHighlightSymbol;

let isParcel=false; 

export const initPlans = (em) => {
  EsriModules = em;

  planBoundarySymbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [0, 0, 0, 0],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: [51, 204, 51],
      width: 5
    }
  };

  planHighlightSymbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [255, 0, 0, 0.25],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      style: "dash",
      color: [181, 151, 107],
      width: 5
    }
  };

  masterHighlightSymbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [255, 0, 0, 0.25],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      style: "dash",
      color: [0, 116, 119],
      width: 5
    }
  };
}

export const processParcelPlans = (results) => {
  Site.addToDisplayMessage("#map-left", "Saving plan detail records...", true);

  highlightGraphicsLayer = EsriModules.mapView.map.findLayerById("highlight");

  let objectIds = [];
  plansDetailTable.length = 0;
  plansMasterTable.length = 0;
  for (let idx = 0; idx < results.length; idx++) {
    objectIds.push(results[idx].feature.attributes.OBJECTID);
    // plansDetailTable.push(results[idx].feature);
  }

  

  findRelatedRecords(objectIds, results);
}

function addRecordsToPlansTable(results) {
  Site.addToDisplayMessage("#map-left", "Organizing plan master records...", true);
  for (let idx = 0; idx < results.length; idx++) {
    let feature = results[idx].feature;

    // Exclude records created just for APNs. These always have a Null Description and DocID
    if (feature.attributes.Description != "Null" && feature.attributes.DocID != 'Null') {
      addPlanIdToMaster(feature);;
      
    }
    

  }

  // results.forEach(function (result) {
    
  //     // console.group("relationship for feature:", objectId)
  //     result.features.forEach(function (feature) {
  //       addPlanIdToMaster(feature);
  //     });
  //     // console.groupEnd();
    
  // });
  // plansMasterTable.sort(sortPlansMasterByDate);
  // buildPlansHtml();
}
function findRelatedRecords(objectIds, results) {
  Site.addToDisplayMessage("#map-left", "Searching for plan master records...", true);

  plansMasterTable.length = 0;
  addRecordsToPlansTable(results);

  // doRelatedQuery(objectIds, 7); // TaxParcels

  doRelatedQuery(objectIds, 5); //Easements
  doRelatedQuery(objectIds, 8); //Lots
  doRelatedQuery(objectIds, 1); //Corner Records
  doRelatedQuery(objectIds, 6); //Subdivisions
  doRelatedQuery(objectIds, 3); //Open_Space
  doRelatedQuery(objectIds, 2); //Biological_Open_Space
  doRelatedQuery(objectIds, 4); //ROW
  buildPlansHtml();




  // // Query related Tax Parcels for given objectIds
  // const query = new EsriModules.RelationshipQuery({
  //   outFields: ["*"],
  //   relationshipId: 7,
  //   // returnGeometry: true,
  //   objectIds: objectIds
  // });

  // let parcelFeatureLayer = new EsriModules.FeatureLayer(Constants.landRecordsUrl + "/5");
  // // parcelFeatureLayer.when(function () {
  // //   console.log("layer relationships", parcelFeatureLayer.relationships.length);
  // //   parcelFeatureLayer.relationships.forEach(function (relationship) {
  // //     console.log("relationship id:", relationship.id)
  // //     console.log("relationship cardinality:", relationship.cardinality)
  // //     console.log("relationship key field:", relationship.keyField)
  // //     console.log("relationship name:", relationship.name)
  // //     console.log("relationship relatedTableId:", relationship.relatedTableId)
  // //   });
  // // });

  // // query related features for given objectIds
  // parcelFeatureLayer.queryRelatedFeatures(query).then(function (result) {
  //   Site.addToDisplayMessage("#map-left", "Organizing plan master records...", true);
  //   objectIds.forEach(function (objectId) {
  //     if (result[objectId]) {
  //       result[objectId].features.forEach(function (feature) {
  //         plansDetailTable.push(feature);
  //       });

  //     }


  //   });



  //   // objectIds.forEach(function (objectId) {
  //   //   if (result[objectId]) {
  //   //     // console.group("relationship for feature:", objectId)
  //   //     result[objectId].features.forEach(function (feature) {
  //   //       addPlanIdToMaster(feature);
  //   //     });
  //   //     // console.groupEnd();
  //   //   }
  //   // });
  //   // plansMasterTable.sort(sortPlansMasterByDate);
  //   buildPlansHtml();
  // });

  // buildPlansHtml();

}

function doRelatedQuery(objectIds, relationshipId) {

  // Query related Tax Parcels for given objectIds
  const query = new EsriModules.RelationshipQuery({
    outFields: ["*"],
    relationshipId: relationshipId,
    returnGeometry: true,
    objectIds: objectIds
  });

  let parcelFeatureLayer = new EsriModules.FeatureLayer(Constants.landRecordsUrl + "/5");

  // query related features for given objectIds
  // query related features for given objectIds
  parcelFeatureLayer.queryRelatedFeatures(query).then(function (result) {
    Site.addToDisplayMessage("#map-left", "Organizing plan master records...", true);
    objectIds.forEach(function (objectId) {
      if (result[objectId]) {
        result[objectId].features.forEach(function (feature) {
          plansDetailTable.push(feature);
        });

      }


    });



    // objectIds.forEach(function (objectId) {
    //   if (result[objectId]) {
    //     // console.group("relationship for feature:", objectId)
    //     result[objectId].features.forEach(function (feature) {
    //       addPlanIdToMaster(feature);
    //     });
    //     // console.groupEnd();
    //   }
    // });
    // plansMasterTable.sort(sortPlansMasterByDate);
    isParcel=false;
    if (relationshipId === 7) {
      isParcel=true;
    }
    buildPlansHtml(isParcel);
  });
}

function addPlanIdToMaster(planMaster) {
  for (let idx = 0, len = plansMasterTable.length; idx < len; idx++) {
    if (plansMasterTable[idx].attributes.OBJECTID === planMaster.attributes.OBJECTID) {
      // console.log("skipped duplicate: ", planMaster.attributes.OBJECTID);
      return;
    }
  }

  let name = planMaster.attributes.Name;
  for (let idx = 0, len = plansDetailTable.length; idx < len; idx++) {
    // console.log("PlanId=" + plansDetailTable[idx].attributes.Name + ", Name=" + name);
    if (plansDetailTable[idx].attributes.Name === name) {
      planMaster.geometry = plansDetailTable[idx].geometry;
      break;
    }
  }

  plansMasterTable.push(planMaster);
  // console.log("attributes: ", planMaster.attributes);
}

function sortPlansMasterByDate(a, b) {
  if (a.attributes.LegalDate < b.attributes.LegalDate)
    return 1;
  if (a.attributes.LegalDate > b.attributes.LegalDate)
    return -1;
  return 0;
}

function buildPlansHtml( isParcel ) {
  Site.addToDisplayMessage("#map-left", "Building plans display...", true);

  $("#map-land-records").empty();

  for (let mIdx = 0, len = plansMasterTable.length; mIdx < len; mIdx++) {
    buildPlanMasterHtml(mIdx);
  }

  Site.hideInfo("#map-left");

  $("#map-land-no-records").hide();
  $("#map-land-records").show();
  $("#map-land-container").show();
}

function buildPlanMasterHtml(mIdx) {
  let attrs = plansMasterTable[mIdx].attributes;
  let data = {
    masterIdx: mIdx
  }
  // Master header
  let div1 = $("<div />", {
    class: "master-results-line"
  });
  let div2 = $("<div />", {
    id: "master-results-item-" + mIdx,
    class: "master-results-expand closed",
    title: "Show/Hide Plan Attributes"
  }).on("click", data, toggleMasterAttributeDisplay);
  let obj = $("<i />", {
    class: showTableClass
  });
  div2.append(obj);
  div1.append(div2);
  div2 = $("<div />", {
    class: "master-results-title",
    html: attrs.Name
  });
  div1.append(div2);
  if (plansMasterTable[mIdx].geometry) {
    div2 = $("<div />", {
      class: "master-results-highlight",
      title: "Show/Hide Plan Boundary"
    }).on("click", data, highlightMasterFeature);
    obj = $("<i />", {
      class: "fas fa-eye"
    }).hover(function () { showMasterBoundary(mIdx, true); }, function () { showMasterBoundary(mIdx, false); });
  } else {
    div2 = $("<div />", {
      class: "master-results-no-highlight"
    });
    obj = $("<i />", {
      class: "fas fa-eye-slash"
    });
  }
  div2.append(obj);
  div1.append(div2);
  $("#map-land-records").append(div1);

  if (!isParcel) {
  // Master attributes
    div1 = $("<div />", {
      class: "master-results-attributes"
    });
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Legal Date: </span>" + Site.getFormattedDate(attrs.LegalDate, false, 10)
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Recording Year: </span>" + attrs.RecordingYear
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Recording Number: </span>" + attrs.RecordingNumber
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Survey Date: </span>" + Site.getFormattedDate(attrs.SurveyDate, false, 10)
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Surveyor: </span>" + attrs.Surveyor
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Company: </span>" + attrs.Company
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Is Plan Residential Development: </span>" + (!attrs.IsPlanResidentialDevelopment || attrs.IsPlanResidentialDevelopment === "N" ? "No" : "Yes")
    });
    div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Description: </span>" + attrs.Description
    });
    div1.append(div2);
    // div2 = $("<div />", {
    //   class: "plan-results-value",
    //   html: "<span>PRDName: </span>" + attrs.PRDName
    // });
    // div1.append(div2);
    div2 = $("<div />", {
      class: "plan-results-value",
      html: "<span>Plan Document: </span>"
    });
    if (attrs.DocURL) {
      obj = $("<a />", {
        class: "plan-results-link",
        href: attrs.DocURL,
        target: "_blank",
        text: "Click Here"
      });
      div2.append(obj);
    }
    div1.append(div2);

    let divMR = $("<div />", {
      id: "master-results-container-" + mIdx,
      class: "master-results-container",
      style: "display:none;"
    });
    divMR.append(div1);

    // buildPlanDetailHtml(attrs.OBJECTID, divMR);
    buildPlanDetailHtml(attrs.GlobalID, divMR);

    $("#map-land-records").append(divMR);
  }
 
}

function buildPlanDetailHtml(oid, masterDiv) {
  let objId = oid.toString();
  for (let idx = 0, len = plansDetailTable.length; idx < len; idx++) {
    // if (plansDetailTable[idx].attributes.PlanID === objId) {
    if (plansDetailTable[idx].attributes.CreatedByRecord === objId) {
      let attrs = plansDetailTable[idx].attributes;
      let data = {
        detailIdx: idx
      }
      // Detail header
      let div1 = $("<div />", {
        class: "plan-results-line"
      });
      let div2 = $("<div />", {
        id: "detail-results-item-" + idx,
        class: "plan-results-expand closed",
        title: "Show/Hide Plan Attributes"
      }).on("click", data, toggleDetailAttributeDisplay);
      let obj = $("<i />", {
        class: showTableClass
      })
      div2.append(obj);
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-title",
        html: attrs.Name
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-highlight",
        title: "Show/Hide Plan Boundary"
      }).on("click", data, highlightDetailFeature);
      obj = $("<i />", {
        class: "fas fa-eye"
      }).hover(function () { showDetailBoundary(idx, true); }, function () { showDetailBoundary(idx, false); });
      div2.append(obj);
      div1.append(div2);
      masterDiv.append(div1);

      // Detail attributes
      div1 = $("<div />", {
        id: "detail-results-container-" + idx,
        class: "detail-results-container",
        style: "display:none;"
      });
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Type: </span>" + attrs.Type
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Legal Start Date: </span>" + (attrs.LegalStartDate === "Null" ? "" : attrs.LegalStartDate)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Legal End Date: </span>" + (attrs.LegalEndDate === "Null" ? "" : attrs.LegalEndDate)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Stated Area: </span>" + (attrs.StatedArea === "Null" ? "" : attrs.StatedArea)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Grant To: </span>" + (attrs.GrantTo === "Null" ? "" : attrs.GrantTo)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Is IOD: </span>" + (attrs.IsIOD === "Null" ? "" : attrs.IsIOD)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Is Private: </span>" + (attrs.IsPrivate === "Null" ? "" : attrs.IsPrivate)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Is Buildable Lot: </span>" + (attrs.IsBuildableLot === "Null" ? "" : attrs.IsBuildableLot)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Historical: </span>" + (attrs.Historical === "Null" ? "" : attrs.Historical)
      });
      div1.append(div2);
      // div2 = $("<div />", {
      //   class: "plan-results-value",
      //   html: "<span>Misclose Distance: </span>" + (attrs.MiscloseDistance === "Null" ? "" : attrs.MiscloseDistance)
      // });
      // div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Max Dwelling Units: </span>" + (attrs.MaxDwellingUnits === "Null" ? "" : attrs.MaxDwellingUnits)
      });
      div1.append(div2);
      div2 = $("<div />", {
        class: "plan-results-value",
        html: "<span>Easement Width: </span>" + (attrs.EasementWidth === "Null" ? "" : attrs.EasementWidth)
      });
      div1.append(div2);
      masterDiv.append(div1);
    }
  }
}

function toggleMasterAttributeDisplay(event) {
  // console.log("toggleMasterAttributeDisplay: masterIdx=" + event.data.masterIdx);
  let iconObj = $("#master-results-item-" + event.data.masterIdx + " i");
  let expandObj = $("#master-results-item-" + event.data.masterIdx);
  let masterObj = $("#master-results-container-" + event.data.masterIdx);
  if (iconObj.hasClass(showTableClass)) {
    iconObj.removeClass(showTableClass);
    iconObj.addClass(hideTableClass);
    expandObj.removeClass("closed");
    expandObj.addClass("open");
    masterObj.show();
  } else {
    iconObj.removeClass(hideTableClass);
    iconObj.addClass(showTableClass);
    expandObj.removeClass("open");
    expandObj.addClass("closed");
    masterObj.hide();
  }
}

function toggleDetailAttributeDisplay(event) {
  // console.log("toggleDetailAttributeDisplay: masterIdx=" + event.data.detailIdx);
  let iconObj = $("#detail-results-item-" + event.data.detailIdx + " i");
  let expandObj = $("#detail-results-item-" + event.data.detailIdx);
  let detailObj = $("#detail-results-container-" + event.data.detailIdx);
  if (iconObj.hasClass(showTableClass)) {
    iconObj.removeClass(showTableClass);
    iconObj.addClass(hideTableClass);
    expandObj.removeClass("closed");
    expandObj.addClass("open");
    detailObj.show();
  } else {
    iconObj.removeClass(hideTableClass);
    iconObj.addClass(showTableClass);
    expandObj.removeClass("open");
    expandObj.addClass("closed");
    detailObj.hide();
  }
}

function highlightMasterFeature(event) {
  // console.log("highlightMasterFeature: masterIdx=" + event.data.masterIdx);
  let geometry = plansMasterTable[event.data.masterIdx].geometry;
  let ext = geometry.extent.clone().expand(1.25);
  let graphic = new EsriModules.Graphic({
    geometry: geometry,
    symbol: planBoundarySymbol
  });

  highlightGraphicsLayer.removeAll();
  highlightGraphicsLayer.graphics.add(graphic);

  EsriModules.mapView.goTo(ext);
}

function highlightDetailFeature(event) {
  // console.log("highlightDetailFeature: detailIdx=" + event.data.detailIdx);
  let geometry = plansDetailTable[event.data.detailIdx].geometry;
  let ext = geometry.extent.clone().expand(1.25);
  let graphic = new EsriModules.Graphic({
    geometry: geometry,
    symbol: planBoundarySymbol
  });

  highlightGraphicsLayer.removeAll();
  highlightGraphicsLayer.graphics.add(graphic);

  EsriModules.mapView.goTo(ext);
}

function showMasterBoundary(masterIdx, show) {
  // console.log("showMasterBoundary: masterIdx=" + masterIdx + ", show=" + show);
  if (show) {
    hoverGraphic = new EsriModules.Graphic({
      geometry: plansMasterTable[masterIdx].geometry,
      symbol: masterHighlightSymbol
    });
    highlightGraphicsLayer.add(hoverGraphic);
  } else {
    highlightGraphicsLayer.remove(hoverGraphic);
  }
}

function showDetailBoundary(detailIdx, show) {
  // console.log("showDetailBoundary: detailIdx=" + detailIdx + ", show=" + show);
  if (show) {
    hoverGraphic = new EsriModules.Graphic({
      geometry: plansDetailTable[detailIdx].geometry,
      symbol: planHighlightSymbol
    });
    highlightGraphicsLayer.add(hoverGraphic);
  } else {
    highlightGraphicsLayer.remove(hoverGraphic);
  }
}
